import React from 'react';
import PropTypes from 'prop-types';

import ListHeaderTile from "../header/cell/cell";

export default class GlistHeaderActionsCell extends ListHeaderTile {

    static propTypes = {
        module: PropTypes.object,
        column: PropTypes.object,

        canRemove: PropTypes.bool,
        isFirst: PropTypes.bool,
        isLast: PropTypes.bool,
    }

    render() {
        const classes = Classes("cell", "actions-cell", this.props.column.alignment, this.props.className, {
            'is-first': this.props.isFirst,
            'is-last': this.props.isLast
        });

        /*
            {this.props.module.config.canResizeColumns &&
            <VerticalResizeSeparator className="column-resize-separator" eventPrefix="column" data={{fieldId: this.props.column.fieldId}} type="left" min={0} max={1000}/>}
         */

        return (
            <div className={classes} style={{width:this.props.column.width}}>
                <div className="drop-position i5-triangle-down"/>

                <div className="label">{this.props.column.label}</div>

            </div>
        )
    }
}
